export default "__VITE_ASSET__943wcOYo__"